import { Observable, of, pipe, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { ActivatedRouteSnapshot, CanActivateChild, RouterStateSnapshot, UrlTree } from '@angular/router';

// enums
import { PRODUCT_TYPE } from 'src/app/core/enums/ads/ads-types';

// services
import { GlobleService } from 'src/app/core/services/globle.service';
import { ApiResponseService } from 'src/app/core/services/handel-api-response/api-response.service';


@Injectable({
    providedIn: 'root'
})
export class AdsResloveGuard implements CanActivateChild {
    
    constructor(
        private G: GlobleService,
        private API_RESPONSE: ApiResponseService,        
    ) {}

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | any> | boolean {

        // ES6 Destructuring
        const { id } = childRoute.params || {} 
        const { type } = childRoute.data || {};
        
        //
        let params = {}

        if (this.G.CorrectUserId) {
          params = {
            userId: this.G.CorrectUserId
          }
        }

        const m = () => map((data) => {
                
            childRoute.data = {
                ...childRoute.data,
                ads: data
            }
            
            return true
        });
        
        const c = () => catchError(() => of((() => {
            
            this.G.navigate(['/'])

            return false;

        })()));

        if (id) {

            if (type == PRODUCT_TYPE.request) {
                return this.API_RESPONSE.AdsRequestById(id, { params }).pipe(m(), c())
            }
            
            return this.API_RESPONSE.AdsById(id, { params }).pipe(m(), c())

        }

        return true
        
    }
}